import { Controller } from "@hotwired/stimulus";
import Chart from 'chart.js/auto'

import './style.css'

export default class extends Controller {
  static values = {
    datasets: Array,
    maxY: Number,
  }

  connect(){
    this.setupChart()
  }

  setupChart(){
    const chart = new Chart(this.element, {
      type: 'line',
      data: {
        datasets: [],
      },
      options: {
        animation: false,
        interaction: {
          intersect: false,
          mode: 'x',
        },
        layout: {
          padding: 0,
        },
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            bodyFont: {
              size: 18,
            },
            callbacks: {
              label: (tooltipItem) => {
                const { raw: { label } } = tooltipItem
                return label
              },
            },
            displayColors: false,
            position: 'average',
          },
        },
        responsive: true,
        scales: {
          y: {
            beginAtZero: true,
            suggestedMax: this.maxYValue || undefined,
          }
        },
      }
    })

    this.setupDatasets(chart, this.datasetsValue || [])

    chart.update()
  }

  setupDatasets(chart, datasets = []){
    datasets.forEach((dataset) => {
      chart.data.datasets.push(this.setupDataset(dataset))
    })
  }

  setupDataset(dataset = {}){
    var style = getComputedStyle(document.body)

    const borderColorKey = dataset.is_primary ? '--chart-workload-color' : '--chart-secondary-workload-color'

    return {
      backgroundColor: (context) => {
        if (!context.chart.chartArea){
          return
        }

        const {
          chart: {
            ctx,
            chartArea: {
              top,
              bottom,
            },
          },
        } = context

        const gradientBg = ctx.createLinearGradient(0, top, 0, bottom)
        gradientBg.addColorStop(0, style.getPropertyValue('--chart-gradient-start-color'))
        gradientBg.addColorStop(1, style.getPropertyValue('--chart-gradient-end-color'))

        return gradientBg
      },
      borderCapStyle: 'round',
      borderColor: style.getPropertyValue(borderColorKey),
      borderJoinStyle: 'round',
      borderWidth: 4,
      cubicInterpolationMode: 'monotone',
      data: dataset?.data || [],
      fill: dataset.is_primary,
      label: dataset?.label,
      tension: 0.4,
    }
  }
}
